import React, { useState, useEffect } from 'react'
import { getSurveyTypes } from '../services/search.service';
import { getFilterResults } from '../services/search.service'
import { useDispatch } from 'react-redux';
import { SET_CAMPAIGNS, LOADING, SET_CAMPAIGNS_ASSIGMENTS } from '../redux/action/types'
import { ViewResultsButton } from '../components/ViewResultsButton'
import { DeereContactFilter } from '../components/DeereContactFilter';
import { SupplierFilter } from '../components/SupplierFilter';
import { TypeFilter } from '../components/TypeFilter';
import { StatusFilter } from '../components/StatusFilter';
import { RequestCampaignFilter } from '../components/RequestCampaignFilter'
import { useSelector } from 'react-redux';
import { API_ABORT_ERROR, CRS_REQUEST_STATUS } from '../utils/surveyLiterals'
import { supplierViewFinalSort, orderBy } from '../utils/utils';
import { SupplierFilterNonDeere } from '../components/SupplierFilterNonDeere';
import { CompanyContactFilter } from '../components/CompanyContactFilter';
import { UnitTypeFilter } from '../components/UnitTypeFilter';


export const LeftSearchMenu = ({ authState, isEmployee, userInfo, abortControllerRef }) => {
    const [supplierSelected, setSupplierSelected] = useState(undefined)
    const [deereContactSelected, setDeereContactSelected] = useState(undefined)
    const [nonDeereSupplierSelected, setNonDeereSupplierSelected] = useState(undefined);
    const [companyContactSelected, setCompanyContactSelected] = useState(undefined);
    const [typesSelected, setTypesSelected] = useState(undefined)
    const [statusSelected, setStatusSelected] = useState(undefined)
    const [types, setTypes] = useState([])
    const employeeStatus = useSelector(state => state.filter.statuses)
    const crsSelection = useSelector(state => state.filter.crsSelection)
    const [supplierStatus, setSupplierStatus] = useState(undefined)
    const unitSelection = useSelector((state) => state.filter.unitSelection);
    const [unitSelected, setUnitSelected] = useState(undefined);
    const [showDeereFilter, setShowDeereFilter] = useState(true);
    const [showNonDeereFilter, setShowNonDeereFilter] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
          // Cleanup function to abort any pending requests
          if (abortControllerRef.current) {
            abortControllerRef.current.abort();
          }
        };
      }, []);
    

    const setSupplierStatuses = () => {
        CRS_REQUEST_STATUS.forEach(s => s.checked = false)
        setSupplierStatus(CRS_REQUEST_STATUS)
    }

    const handleEmployeeViewResults = event => {
         event.preventDefault();
        // Abort any pending requests
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
  
        // Create new abort controller
        const newAbortController = new AbortController();
        //Store current controller ref
        abortControllerRef.current = newAbortController;
        dispatch({ type: LOADING, payload: true });
        const reqIndex = crsSelection.findIndex(es => es.selected)
        const filters = JSON.stringify({
            supplierNumber: supplierSelected === '' ? undefined : supplierSelected,
            deereContact: deereContactSelected === '' ? undefined : deereContactSelected,
            type: typesSelected !== null && typesSelected !== undefined && typesSelected.length <= 0 ? undefined : typesSelected,
            status: statusSelected !== null && statusSelected !== undefined && statusSelected.length <= 0 ? undefined : statusSelected,
            request: reqIndex > -1 ? [crsSelection[reqIndex].code] : ['Request'],
            unit: unitSelected !== null && unitSelected !== undefined && unitSelected.length <=0 ? undefined : unitSelected,
            nonDeereSupplierNumber: nonDeereSupplierSelected === '' ? undefined : nonDeereSupplierSelected,
            companyContact: companyContactSelected === '' ? undefined : companyContactSelected,
        })
        return getFilterResults(filters, authState.accessToken.accessToken, true, newAbortController.signal)
            .then(f => {
                const finalSort = orderBy(f)
                dispatch({ type: SET_CAMPAIGNS, payload: finalSort })
                dispatch({ type: LOADING, payload: false })
                return f;
            })
            .catch(e => {
                console.log(e.name, e.message);
                if (e.name !== API_ABORT_ERROR) {
                    dispatch({ type: LOADING, payload: false })
                }
            })
    }

    const handleSupplierViewResults = event => {
        dispatch({ type: LOADING, payload: true })
        // Abort any pending requests
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
  
        // Create new abort controller
        const newAbortController = new AbortController();
        //Store current controller ref
        abortControllerRef.current = newAbortController;
        const filters = JSON.stringify({
            type: typesSelected !== null && typesSelected !== undefined && typesSelected.length <= 0 ? undefined : typesSelected,
            status: statusSelected !== null && statusSelected !== undefined && statusSelected.length <= 0 ? undefined : statusSelected,
            supplierNumbers: userInfo.suppliers,
        })
        return getFilterResults(filters, authState.accessToken.accessToken, false, newAbortController.signal)
            .then(f => {
                const finalSort = supplierViewFinalSort(f)
                dispatch({ type: SET_CAMPAIGNS_ASSIGMENTS, payload: finalSort })
                dispatch({ type: LOADING, payload: false })
                return f;
            })
            .catch(e => {
                console.log(e.message)
                if (e.name !== API_ABORT_ERROR) {
                    dispatch({ type: LOADING, payload: false })
                }
            })
    }

    useEffect(() => {
        async function getTypesFilter() {
            if (!isEmployee)
                setSupplierStatuses()
            getSurveyTypes(authState.accessToken.accessToken)
                .then(response => setTypes(response))
                .catch(error => console.log(error))
        }
        getTypesFilter()
    }, [authState.accessToken.accessToken,isEmployee])



    const employeeLeftMenu = <>
        <RequestCampaignFilter setStatusSelected={setStatusSelected} />
        <UnitTypeFilter setUnitSelected={setUnitSelected} units={unitSelection} unitSelected={unitSelected} setShowDeereFilter={setShowDeereFilter} setShowNonDeereFilter={setShowNonDeereFilter}/>
        {showDeereFilter &&
            <>
                <SupplierFilter setSupplierSelected={setSupplierSelected} abortControllerRef={abortControllerRef} />
                <DeereContactFilter setDeereContactSelected={setDeereContactSelected} abortControllerRef={abortControllerRef} />
            </>
        }
        {showNonDeereFilter &&
            <>
                <SupplierFilterNonDeere setNonDeereSupplierSelected={setNonDeereSupplierSelected} abortControllerRef={abortControllerRef} />
                <CompanyContactFilter setCompanyContactSelected={setCompanyContactSelected} abortControllerRef={abortControllerRef} />
            </>
        }
        <TypeFilter setSelected={setTypesSelected} types={types} selected={typesSelected} />
        <StatusFilter setSelected={setStatusSelected} status={employeeStatus} selected={statusSelected} />
        <br />
        <ViewResultsButton filterDataOnClick={handleEmployeeViewResults} />
    </>

    const supplierLeftMenu = <>
        <TypeFilter setSelected={setTypesSelected} types={types} selected={typesSelected} />
        <StatusFilter setSelected={setStatusSelected} status={supplierStatus} selected={statusSelected} />
        <br />
        <ViewResultsButton filterDataOnClick={handleSupplierViewResults} />
    </>

    return isEmployee ? employeeLeftMenu : supplierLeftMenu

}
